import { mapActions } from 'vuex'
import { ACCOUNT_CLEAR, ACCOUNT_DETAILS } from '@/store/types'

export default
{
	props:
	{
		accountNumber:
		{
			type:     String,
			required: true,
		},
	},

	watch:
	{
		accountNumber:
		{
			immediate: true,

			handler(accountNumber)
			{
				return this.loadAccount({ accountNumber })
			},
		},
	},

	methods:
	{
		...mapActions
		({
			clearAccount: ACCOUNT_CLEAR,
			loadAccount:  ACCOUNT_DETAILS,
		}),
	},

	beforeDestroy()
	{
		this.clearAccount()
	},
}